import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import HomePage from './components/home/index.vue';
export default {
  __name: 'App',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(HomePage);
    };
  }
};